/* eslint-disable no-use-before-define */
import { useEffect, useState } from 'react';

const useSearchHook = () => {
  const [searchValue, setSearchValue] = useState('');

  useEffect(() => {
    searchHelper();
  }, [searchValue]);

  const searchHelper = (records, searchKeys) => {
    if (!records || !searchKeys || !searchValue) return;

    const filteredRecords = records?.filter((record) =>
      searchKeys
        ?.map(
          (searchKey) =>
            record?.[searchKey]?.toLowerCase()?.indexOf(searchValue?.toLowerCase()) > -1,
        )
        ?.find((f) => f),
    );

    // eslint-disable-next-line consistent-return
    return filteredRecords;
  };

  return { searchValue, setSearchValue, searchHelper };
};

export default useSearchHook;
